import axios from "axios"
import { tryFireSessionReplaced, tryFireAdminIpDenied } from "./sessionGuard"
import { attachCsrfInterceptor } from "./csrf"
import { API_BASE } from "../config/paths"
import { isAdminIpDenied } from "../utils/adminIpError"

const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true  // sends the httpOnly session cookie on every request
})

attachCsrfInterceptor(api)

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401 && error.response?.data?.code === "SESSION_REPLACED") {
            if (tryFireSessionReplaced()) {
                localStorage.removeItem("user")
                window.dispatchEvent(new CustomEvent("session-replaced"))
            }
        }
        if (isAdminIpDenied(error)) {
            if (tryFireAdminIpDenied()) {
                localStorage.removeItem("user")
                window.dispatchEvent(new CustomEvent("admin-ip-denied", {
                    detail: { message: error.response?.data?.error },
                }))
            }
        }
        return Promise.reject(error)
    }
)

export default api
